import { useActions, useApiActions, useData, usePending } from "state/hooks";
import {
    exportWebsite,
    importWebsite,
    submitCreateWebsite,
} from "cms/state/actions/services";
import { deleteSuccess } from "state/actions/delete";
import { useMemo } from "react";

export function useCreateWebsite({ type, id }) {
    const { onExport, onImport, onSubmit } = useApiActions({
        onExport: exportWebsite,
        onImport: importWebsite,
        onSubmit: submitCreateWebsite,
    });

    const { onReset } = useActions({
        onReset: deleteSuccess,
    });

    const { status } = useData({ type, id });
    const isPending = usePending(id);

    return useMemo(
        () => ({
            onExport,
            onImport,
            onSubmit: () => onSubmit(id),
            onReset: () => onReset(type, id),
            status,
            isPending,
        }),
        [onExport, onImport, onSubmit, onReset, type, id, status, isPending]
    );
}
